import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';

/**
 * HERO — standalone full-screen split slide (kept exactly as the original
 * "Slide 1"). Left: Barcelona dock portrait. Right: cream panel with logo,
 * headline, subtitle and the two CTAs. The credibility / philosophy / meet
 * Melinda pages now live in the horizontal-scroll IntroScrollSection.
 */
const StickyHeroPanel = () => {
  const { t } = useLanguage();

  const scrollToOfferings = () =>
    document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
  const scrollToMethod = () =>
    document.getElementById('soulboard-method')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section
      className="relative w-full"
      style={{ background: '#faf7ee' }}
      data-testid="hero-section"
    >
      <div className="flex flex-col lg:flex-row min-h-screen w-full items-stretch">
        {/* LEFT — portrait */}
        <div className="relative w-full lg:w-[58.333%] h-[55vh] lg:h-auto overflow-hidden flex-shrink-0">
          <img
            src="/melinda-hero-barcelona.jpg"
            alt=""
            className="elle-photo absolute inset-0 w-full h-full object-cover"
            style={{ objectPosition: 'center 30%' }}
            loading="eager"
            data-testid="slide-image-hero"
          />
        </div>

        {/* RIGHT — cream content panel */}
        <div
          className="relative w-full lg:w-[41.667%] flex items-center justify-center px-8 lg:px-14 py-16 lg:py-0 self-stretch"
          style={{ background: '#faf7ee' }}
        >
          <div className="max-w-md w-full space-y-7">
            <img
              src="/soulboard-logo.png"
              alt="Soulboard"
              className="w-44 lg:w-52"
              style={{ mixBlendMode: 'multiply', filter: 'contrast(1.2)' }}
            />
            <h1
              className="hero-title text-neutral-900 leading-[0.95]"
              style={{
                fontWeight: 400,
                letterSpacing: '0.005em',
                fontSize: 'clamp(2.5rem, 5.5vw, 4.5rem)',
              }}
              data-testid="hero-title"
            >
              {t('heroTitle1')}
              <br />
              {t('heroTitle2')}
            </h1>
            <p className="text-base lg:text-lg text-neutral-700 leading-relaxed">
              {t('heroSubtitle')}
            </p>
            <div className="flex flex-col sm:flex-row gap-3 pt-2">
              <motion.button
                onClick={scrollToOfferings}
                data-testid="start-journey-btn"
                className="px-7 py-4 text-neutral-900 text-sm uppercase tracking-wider font-bold"
                style={{ background: '#d4ff00' }}
                whileHover={{ scale: 1.02, boxShadow: '0 8px 20px rgba(0,0,0,0.12)' }}
                whileTap={{ scale: 0.98 }}
              >
                {t('startJourneyCta')}
              </motion.button>
              <motion.button
                onClick={scrollToMethod}
                data-testid="discover-method-btn"
                className="px-7 py-4 text-neutral-900 text-sm uppercase tracking-wider font-bold border-2 border-neutral-900 bg-transparent"
                whileHover={{ scale: 1.02, background: '#171717', color: '#faf7ee' }}
                whileTap={{ scale: 0.98 }}
              >
                {t('discoverMethodCta')}
              </motion.button>
            </div>
            <p className="text-xs uppercase tracking-[0.3em]" style={{ color: '#7d65b8' }}>
              {t('limitedSpots')}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StickyHeroPanel;
